import { render, staticRenderFns } from "./yesTag.vue?vue&type=template&id=a67664a2"
import script from "./yesTag.vue?vue&type=script&lang=js"
export * from "./yesTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports